const publicInfo = `<div class="whnr"><p style="text-align:left;">
<br>
</p>
<div style="text-align:left;">
</div>
<table width="777" border="0" cellpadding="0" cellspacing="0" style="font-family:" width:388.5pt;"="" class="ke-zeroborder">
<tbody>
<tr>
    <td class="xl71" height="34" width="259" style="vertical-align:middle;font-size:10pt;font-weight:700;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        披露机构全称:
    </td>
    <td class="xl72" width="259" style="vertical-align:middle;font-size:10pt;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        上海妙保保险经纪股份有限公司
    </td>
    <td class="xl70" width="259" style="vertical-align:middle;color:windowtext;font-size:10pt;font-family:宋体;border:none;">
    </td>
</tr>
<tr>
    <td class="xl71" height="29" style="vertical-align:middle;font-size:10pt;font-weight:700;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        披露机构简称:
    </td>
    <td class="xl72" style="vertical-align:middle;font-size:10pt;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        妙保公司
    </td>
    <td class="xl70" style="vertical-align:middle;color:windowtext;font-size:10pt;font-family:宋体;border:none;">
    </td>
</tr>
<tr>
    <td class="xl71" height="29" style="vertical-align:middle;font-size:10pt;font-weight:700;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        经营互联网保险业务的网站名称：
    </td>
    <td class="xl72" style="vertical-align:middle;font-size:10pt;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        妙保保险经纪
    </td>
    <td class="xl70" style="vertical-align:middle;color:windowtext;font-size:10pt;font-family:宋体;border:none;">
    </td>
</tr>
<tr>
    <td class="xl71" height="58" style="vertical-align:middle;font-size:10pt;font-weight:700;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        经营互联网保险业务的网站地址：
    </td>
    <td class="xl72" style="vertical-align:middle;font-size:10pt;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        http://www.trib.com.cn/；<br>
http://www.miaoins.com/
    </td>
    <td class="xl70" style="vertical-align:middle;color:windowtext;font-size:10pt;font-family:宋体;border:none;">
    </td>
</tr>

<tr>
    <td class="xl71" height="58" style="vertical-align:middle;font-size:10pt;font-weight:700;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        经营互联网保险业务的微信公众号名称：
    </td>
    <td class="xl72" style="vertical-align:middle;font-size:10pt;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        妙保；T博士说险
    </td>
    <td class="xl70" style="vertical-align:middle;color:windowtext;font-size:10pt;font-family:宋体;border:none;">
    </td>
</tr>
<tr>
    <td class="xl71" height="29" style="vertical-align:middle;font-size:10pt;font-weight:700;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        客户服务及消费者投诉电话：
    </td>
    <td class="xl72" style="vertical-align:middle;font-size:10pt;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        400-103-1660
    </td>
    <td class="xl70" style="vertical-align:middle;color:windowtext;font-size:10pt;font-family:宋体;border:none;">
    </td>
</tr>
<tr>
    <td class="xl71" height="58" style="vertical-align:middle;font-size:10pt;font-weight:700;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        机构信息披露网站地址：
    </td>
    <td class="xl72" style="vertical-align:middle;font-size:10pt;font-family:微软雅黑, sans-serif;border:0.5pt solid windowtext;text-align:center;">
        <a href="http://icid.iachina.cn/ICID/" target="_parent">www.trib.com.cn；<br>
www.miaoins.com</a> 
    </td>
    <td class="xl70" style="vertical-align:middle;color:windowtext;font-size:10pt;font-family:宋体;border:none;">
    </td>
</tr>
<tr>
    <td class="xl70" height="26" colspan="3" style="vertical-align:middle;color:windowtext;font-size:10pt;font-family:宋体;border:none;">
    </td>
</tr>

</tbody>
</table>
<img src="${require("../images/table.jpg")}" style="width:700px" />
<p style="text-align:center;">
    <br>
</p></div>`;
const CULTUREE = `
<font style="margin-left: -2em;">1、妙保立业之道</font><br/>
惠济社会，上善若水滋润万物而长流，妙保之道惠济社会而久立。<br/>
2、妙保精神<br/>
铁肩担道义，妙保献精神。为客户规避风险，为员工打造发展平台，为保险公司提供保险业务，为股东赢得保险投资效益，为民族振兴保险经纪事业。<br/>
3、妙保经营之德<br/>
设身处地，推己及人，己所不欲，勿施于人。<br/>
对人重之以德，施之以仁，行之以善。<br/>
奉行人本文化系妙保公司秉持的经营管理之德。<br/>
4、妙保宗旨<br/>
崇尚诚信为最高理念，专业水准为技术核心，规范经营为成功之路，优质服务为竞争之本，健康持续为发展目标。<br/>
5、妙保价值观念<br/>
利益共享，互利共赢。<br/>
客户、员工、股东精诚合作，相互依存，以共同利益为处事原则，以惠济社会为立世大境界。<br/>
6、妙保用人理念<br/>
坚持“德才兼备德为先，诚勉相济诚为贵”的用人原则，亦辅之德才殊用的用人之术。<br/>
论德才择其位，视能力任其职，以贡献奖其利。<br/>
7、妙保司风：<br/>
精诚笃实，团结互助；艰苦奋斗，勤劳简朴；崇礼尚义，明廉知耻。<br/>
员工心语：精诚所至，金石为开。养心莫善于诚。舍生取义；有耻且格。把公司培育成温良恭俭让的良好风气。<br/>
8、妙保员工的荣辱观：<br/>
以遵纪守法为荣 以违法乱纪为耻；以诚实守信为荣 以见利忘义为耻；以艰苦奋斗为荣 以骄奢浪费为耻<br/>
以团结互助为荣 以损人利己为耻；以辛勤劳动为荣 以好逸恶劳为耻<br/>
9、妙保发展战略思想<br/>
公司建设总目标：以全面建设公司为主题、以业务发展为中心、以提高队伍素质为重点、以健康持续发展为目标。<br/>
10、业务发展的哲学思想<br/>
稳健经营，循序渐进。奋勇拼搏，力求实效。必要投入，有效汇报。<br/>
11、公司发展阶段性目标<br/>
站在高处，看到远处，干在实处。一年一个新台阶，三年一个新阶段，五年一个新起点。<br/>
12、管理工作的三个环节<br/>
及时发现苗头，切实弄清性质，正确解决问题。<br/>
13、管理者的基本素质<br/>
——以宽广的胸怀容纳人<br/>
虚怀若谷，善于听取不同意见；笑迎挑战，勇于承担各种责任。<br/>
——以先进的思想引导人<br/>
勇破樊篱，思维常新。求知若渴，知识常新。修身养德，觉悟常新。<br/>
——以科学的领导艺术统御人<br/>
识能选贤，知人善任；教管相济，善于激励；授权督责，各司其位。<br/>
——以高尚人格魅力影响人<br/>
尊重他人，真诚相待。严格自律，率先垂范。大局为重，勇于奉献。`;
const LETTER = `
    <p>社会各界的朋友们、保险业界的同行们：</p>
    
    <p>保险经纪是我国新兴的朝阳产业，它发挥着连接产品与市场、沟通客户与保险公司的桥梁作用。它是客户利益的保护神；保险公司的有力合作者；保险领域不可或缺的重要环节，是我国保险业内合理分工、规范服务、与国际接轨的重要体现。</p>

    <p>上海妙保保险经纪股份有限公司（以下简称妙保保险经纪或妙保）顺应时代的脉搏，应运而生。它发起于江苏，诞生于上海，发展于中华大地。妙保公司成立伊始，就得到了社会各方的关注，获得了各界志士贤达的鼎力扶持，赢得了众多客户的信任。这些源源不断的动力大大激发了我们“妙保”员工的旺盛斗志，坚定了我们发展保险经纪事业的信心。社会向“妙保”投之以信，“妙保”必将报之以德。</p>
    <p>妙保公司的企业文化是公司发展灵魂和管理基础。公司具有鲜明的时代精神、强烈的群体意识、正确的激励原则、高度的社会责任、明确的价值观念、科学求实的奋斗目标。“妙保”将遵循“惠济社会”的立业之道，坚持诚信于客户的经营之本，以服务树品牌，以品牌创效益，将品牌的价值体现在对客户的优质服务之中。</p>
    <p>妙保保险经纪将秉持：以自己一双热情的手，一手牵着客户，一手牵着保险公司，三者利益兼顾，互惠互利共赢；坚持客户、股东、员工三方精诚合作，相互依存，共谋发展；坚定不移地奉行人本文化，建设高效团队，以强烈的事业心和高度的责任感为客户保驾护航，为员工构筑施展才能的舞台，为保险公司扩展业务，为股东创造投资效益，为中国的保险经纪事业跻身于世界保险经纪之林贡献力量。</p>`;
const columns1 = [
  {
    title: "保险公司",
    key: "company"
  },
  {
    title: "实际销售名称",
    key: "salename"
  },
  {
    title: "备案产品名称",
    key: "name"
  },
  {
    title: "备案编号/批复文号",
    key: "id"
  },
  {
    title: "验真途径",
    key: "way"
  }
];
const data1 = [
  {
    company: "众惠财产相互保险社",
    salename: "抗压卫士",
    name: "众惠财产相互保险社高血压并发症住院医疗费用保险互联网专属条款",
    id: "kyws22041",
    way:
      "您可登录众惠相互官网https://www.pubmi.cn/policy/verify.html查询验证,或拨打400-919-0505客服电话。"
  },
  {
    company: "平安健康保险股份有限公司",
    salename: "平安e生保",
    name:
      "平安e生保互联网住院医疗保险，平安互联网特定疾病特需医疗保险，平安互联网亚洲特定治疗医疗保险",
    id: "平保健发〔2021〕196号，平保健发〔2021〕324号，平保健发〔2021〕324号",
    way:
      "您可以登录https://health.pingan.com/P/C/PAH/welcome查询验证，或拨打95511-7客服电话。"
  },
  {
    company: "平安健康保险股份有限公司",
    salename: "终身防癌医疗险",
    name:
      "平安互联网特定疾病特需医疗保险，平安互联网质子重离子医疗保险，平安互联网长期癌症医疗保险（费率可调）",
    id:
      "平保健发〔2021〕324号，平安健康〔2021〕医疗保险093号，保健发〔2021〕292号，平安健康〔2021〕医疗保险086号，平保健发〔2021〕291号，平安健康〔2021〕医疗保险082号",
    way:
      "您可以登录https://health.pingan.com/P/C/PAH/welcome查询验证，或拨打95511-7客服电话。"
  }
  // {
  //   company: "中国大地财产保险股份有限公司",
  //   salename: "大地百万医疗",
  //   name: ` 中国大地保险个人医疗保险条款（C款）；大地通达公共交通工具意外伤害保险条款；中国大地保险个人医疗保险（C款）
  //               附加扩展恶性肿瘤特需医疗保险条款 ；中国大地保险
  //               附加个人恶性肿瘤院外特种药品费用医疗保险条款；中国大地保险
  //               附加个人恶性肿瘤赴日医疗保险条款；附加个人恶性肿瘤扩展质子重离子医疗保险条款`,
  //   id: `              C00001032512019122304252；(大地财险)(备-意外)【2014】(主)28号；C00001032522019122304412；中国大地保险
  //               附加个人恶性肿瘤院外特种药品费用医疗保险条款
  //               ；C00001032522019122304292；中国大地保险
  //               附加个人恶性肿瘤赴日医疗保险条款；C00001032522019122304272；中国大地保险
  //               附加个人恶性肿瘤扩展质子重离子医疗保险条款
  //               ；C00001032522019122304332`
  // },
  // {
  //   company: "中国大地财产保险股份有限公司",
  //   salename: "天地关爱百万医疗",
  //   name: `中国大地保险个人医疗保险（C款）`,
  //   id: `C00001032512019122304252`
  // },
  // {
  //   company: "众惠财产相互保险社",
  //   salename: "惠享e生 众惠百万医疗",
  //   name: `众惠财产相互保险社个人医疗费用保险（C 款）条款`,
  //   id: `C00022132512019091705851`
  // },
  // {
  //   company: "众惠财产相互保险社",
  //   salename: "护肝卫士肝病保障计划",
  //   name: `众惠财产相互保险社特定肝脏恶性肿瘤疾病保险条款`,
  //   id: `C00022132612019092500482`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "e生保2020",
  //   name: `平安e生保个人住院医疗保险`,
  //   id: `平保健发[2019]187号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "e生保2020（开门红版）",
  //   name: `平安e生保个人住院医疗保险`,
  //   id: `平保健发[2019]187号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "e生保·长期医疗（费率可调）",
  //   name: `平安e生保长期个人住院医疗保险（费率可调）`,
  //   id: `平保健发〔2020〕179号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "e生保plus",
  //   name: `平安e生保（2017）医疗保险`,
  //   id: `平保健发[2019]80号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "平安e生保（保证续保版）",
  //   name: `平安e生保（保证续保版2020）医疗保险`,
  //   id: `平保健发〔2019〕190号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "i康保·百万医疗",
  //   name: `平安i康保个人医疗保险`,
  //   id: `平保健发〔2020〕1号-1`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "i康保·少儿意外",
  //   name: `平安i康保意外伤害保险`,
  //   id: `平保健发〔2018〕156号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "i康保·综合意外",
  //   name: `平安i康保意外伤害保险`,
  //   id: `平保健发〔2018〕156号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "i康保·重疾",
  //   name: `平安i康保重大疾病保险`,
  //   id: `平保健发〔2020〕1号-2`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "i康保·重疾少儿版",
  //   name: `平安i康保重大疾病保险`,
  //   id: `平保健发〔2020〕1号-2`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "e生保plus",
  //   name: `平安健康〔2018〕医疗保险011号`,
  //   id: `平保健发〔2018〕97号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "e生保（2017版）",
  //   name: `平安健康〔2018〕医疗保险011号`,
  //   id: `平保健发〔2018〕97号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "e生保（加强版）",
  //   name: `平安健康〔2018〕医疗保险014号`,
  //   id: `平保健发〔2018〕97号`
  // },
  // {
  //   company: "平安健康保险股份有限公司",
  //   salename: "e家保2018",
  //   name: `平安健康〔2018〕医疗保险025号`,
  //   id: `平保健发〔2018〕98号`
  // },
  // {
  //   company: "亚太财产保险有限公司",
  //   salename: "E家无忧",
  //   name: `亚太财产保险有限公司住院医疗保险(A款)-条款`,
  //   id: `C00003832512021040237511`
  // },
  // //   {
  // //     company: "泰康人寿保险有限责任公司",
  // //     salename: "泰康瑞医保",
  // //     name: `泰康e顺B款重大疾病保险条款；泰康e顺短期意外伤害医疗保险条款；泰康瑞心医疗保险条款`,
  // //     id: `泰康人寿[2019]疾病保险023号；泰康人寿[2018]医疗保险142号；泰康人寿[2020]医疗保险062号`,
  // //   },
  // {
  //   company: "百年人寿保险股份有限公司",
  //   salename: "百年医惠通费用补偿医疗保险",
  //   name: `百年医惠通费用补偿医疗保险`,
  //   id: `百年人寿[2019]医疗保险043号`
  // },
  // {
  //   company: "百年人寿保险股份有限公司",
  //   salename: "百年医无忧特定疾病医疗保险",
  //   name: `百年医无忧特定疾病医疗保险`,
  //   id: `百年人寿[2019]医疗保险045号`
  // },
  // {
  //   company: "百年人寿保险股份有限公司",
  //   salename: "百年药惠通特种药品费用医疗保险",
  //   name: `百年药惠通特种药品费用医疗保险`,
  //   id: `百年人寿[2019]医疗保险059号`
  // },
  // {
  //   company: "阳光人寿保险股份有限公司",
  //   salename: "i保终身重疾保险2019版",
  //   name: `阳光人寿i保C款终身重大疾病保险；阳光人寿附加豁免保险费E款疾病保险`,
  //   id: `阳光人寿[2019]78号；阳光人寿[2020]130号-4`
  // },
  // {
  //   company: "阳光人寿保险股份有限公司",
  //   salename: "i保万安返本意外保险计划",
  //   name: `阳光人寿i保万安两全保险；阳光人寿附加i保万安意外伤害保险`,
  //   id: `阳光人寿[2019]518号-1；阳光人寿[2019]518号-2`
  // },
  // {
  //   company: "阳光人寿保险股份有限公司",
  //   salename: "神农6年期癌症医疗险",
  //   name: `阳光人寿i保恶性肿瘤医疗保险`,
  //   id: `阳光人寿[2019]559号-1`
  // },
  // {
  //   company: "阳光人寿保险股份有限公司",
  //   salename: "孝顺保老年防癌险",
  //   name: `阳光人寿孝顺保恶性肿瘤疾病保险`,
  //   id: `阳光人寿[2020]93号-16`
  // },
  // {
  //   company: "太平财产保险有限公司",
  //   salename: "太平爱齿健普惠齿科保险",
  //   name: `《齿科医疗保险B款条款》`,
  //   id: `(太平财险)(备-医疗保险)【2019】(主) 008号`
  // }
];

const columns2 = [
  {
    title: "合作机构名称",
    key: "company"
  },
  {
    title: "业务合作范围",
    key: "range"
  },
  {
    title: "服务电话",
    key: "tele"
  },
  {
    title: "省级分支机构和落地服务机构的省",
    key: "province"
  },
  {
    title: "合作期限",
    key: "date"
  }
];
const data2 = [
  {
    company: `众安在线财产保险股份有限公司`,
    range: `短期健康险`,
    tele: `10109955`,
    province: `全国性的互联网专业保险公司，在中华人民共和国境内（港、澳、台地区除外）开展与互联交易直接相关的保险业务，不设分支机构`,
    date: `2021/6/20-2022/6/19`
  },
  {
    company: `中国大地财产保险股份有限公司`,
    range: `短期健康险`,
    tele: `95590`,
    province: `全国`,
    date: `2020/1/1-2023/12/31`
  },
  {
    company: `众惠财产相互保险社`,
    range: `健康险、意外险`,
    tele: `400-919-0505`,
    province: `不设分支机构`,
    date: `2020/1/1-2024/12/31`
  },
  {
    company: `平安健康保险股份有限公司`,
    range: `人寿险、健康险、意外险 `,
    tele: `95511转7`,
    province: `北京、上海、天津、广东、深圳、江苏、浙江、辽宁（除大连）、四川、苏州、河北、重庆、河南、湖北、湖南`,
    date: `2020/1/1-2023/12/31`
  },
  // {
  //   company: `众惠财产相互保险社`,
  //   range: `短期健康险`,
  //   tele: `400-919-0505`,
  //   province: `全国`,
  //   date: `2020/1/1-2021/12/31`
  // },
  // {
  //   company: `平安健康保险股份有限公司`,
  //   range: `短期健康险`,
  //   tele: `95511转7`,
  //   province: `全国`,
  //   date: `2020/11/13-2022/6/21`
  // },
  {
    company: `亚太财产保险有限公司`,
    range: `短期健康险`,
    tele: `95506`,
    province: `北京、天津、上海、广东、深圳、江苏、浙江、宁波、山东、湖南、湖北、四川、辽宁、河南、河北、安徽、福建、海南、重庆、香港、内蒙古、陕西、云南`,
    date: `2021/7/1-2022/6/30`
  },
  {
    company: `泰康人寿保险有限责任公司`,
    range: `短期健康险`,
    tele: `95522`,
    province: `全国`,
    date: `2021/2/1-2022/1/31`
  },
  {
    company: `百年人寿保险股份有限公司`,
    range: `短期健康险`,
    tele: `95542`,
    province: `大连、湖北、河北、辽宁、北京、河南、黑龙江、安徽、山东、江苏、
        四川、福建、陕西、内蒙古、吉林、江西、浙江、山西、广东、重庆`,
    date: `2019/11/18-2021/11/17`
  },
  {
    company: `阳光人寿保险股份有限公司`,
    range: `短期健康险`,
    tele: `95510`,
    province: `全国`,
    date: `2021/7/7-2022/6/30`
  },
  {
    company: `太平财产保险有限公司`,
    range: `短期健康险`,
    tele: `95589`,
    province: `北京、广东、上海、深圳、天津、湖北、大连、浙江、四川、江苏、山东、河南、青岛、湖南、重庆、福建、山西、陕西、安徽、辽宁、河北、云南、贵州、宁波、黑龙江、广西、厦门、苏州、内蒙古、江西、吉林、甘肃、海南`,
    date: `2021/10/13-2023/10/12`
  }
];

export { publicInfo, CULTUREE, LETTER, columns1, data1, columns2, data2 };



// WEBPACK FOOTER //
// ./src/components/components/text.js